import "babel-polyfill";
import "core-js";
import { APP_INITIALIZER, enableProdMode } from '@angular/core';

import { environment } from './environments/environment';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { bootstrapApplication } from '@angular/platform-browser';
import { provideRouter } from '@angular/router';
import { AppComponent } from './app/app.component';
import { routes } from './app/app-routing.module';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppConfig } from './app/app.config';
import { CustomDateAdapter } from './app/journey/calendar/custom-date-adapter';
import { HttpInterceptorInterceptor } from './app/services/http-interceptor.interceptor';
import { provideAnimations } from '@angular/platform-browser/animations';
import { AddressLookupStatusComponent } from "@bookinglab/hwrc-ui";

if (environment.production) {
  enableProdMode();
}

export function initializeApp(appConfig: AppConfig) {
  return () => appConfig.load();
}

bootstrapApplication(AppComponent, {
  providers: [
    provideTranslateService({
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: '.json',
      }),
      fallbackLang: 'en',
      lang: 'en',
    }),
    AppConfig,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeApp,
      deps: [AppConfig],
      multi: true,
    },
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
    {
      provide: MAT_DATE_LOCALE,
      useValue: 'en-GB',
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorInterceptor,
      multi: true,
    },
    provideHttpClient(withInterceptorsFromDi()),
    provideRouter(routes),
    provideAnimations(),
    AddressLookupStatusComponent
  ],
});

